import { Misc } from "@/data/util/Misc";

function isEmptyPrice(price: number, displayZeroAmount: boolean) {
    return isNaN(price) || price === null || price === undefined || (!displayZeroAmount && price === 0);
}

export function toMoney(
    price: number,
    displayZeroAmount: boolean = false,
    locale: string = "en-CH",
    displayDecimals: boolean = true
) {
    if (isEmptyPrice(price, displayZeroAmount)) {
        return "";
    }

    return Misc.roundCents(price).toLocaleString(locale ?? "en-CH", { minimumFractionDigits: displayDecimals ? 2 : 0 });
}

export function toMoneyWithSign(
    price: number,
    displayZeroAmount: boolean = false,
    locale: string = "en-CH",
    displayDecimals: boolean = true
) {
    if (isEmptyPrice(price, displayZeroAmount)) {
        return "";
    }

    return Misc.roundCents(price).toLocaleString(locale ?? "en-CH", {
        style: "currency",
        currency: "CHF",
        minimumFractionDigits: displayDecimals ? 2 : 0,
    });
}

export function toFormattedNumber(price: number, locale: string = "en-CH", displayDecimals: boolean = false) {
    return Misc.roundCents(price).toLocaleString(locale ?? "en-CH", { minimumFractionDigits: displayDecimals ? 2 : 0 });
}
